<template>
  <div>
    <div class="ts-space-y-2">
      <div class="row">
        <div class="col-md-12">
          <label class="ts-text-xs required">{{
            $t('luckyDrawAvailableItem.eventName')
          }}</label>
          <input
            type="text"
            class="form-control"
            v-model.trim="model.event_name"
          />
          <div class="validate ts-text-xs" v-if="errors.has('event_name')">
            {{ errors.first('event_name') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label class="required">{{
            $t('luckyDrawAvailableItem.eventStartDate')
          }}</label>
          <a-date-picker
            v-model="model.event_start_date"
            format="DD-MM-YYYY"
            :allowClear="false"
            valueFormat="DD-MM-YYYY"
            class="ts-w-full"
          ></a-date-picker>
          <div
            class="validate ts-text-xs"
            v-if="errors.has('event_start_date')"
          >
            {{ errors.first('event_start_date') }}
          </div>
        </div>
        <div class="col-md-6">
          <label class="required">{{
            $t('luckyDrawAvailableItem.eventEndDate')
          }}</label>
          <a-date-picker
            v-model="model.event_end_date"
            format="DD-MM-YYYY"
            :allowClear="false"
            valueFormat="DD-MM-YYYY"
            class="ts-w-full"
          ></a-date-picker>
          <div class="validate ts-text-xs" v-if="errors.has('event_end_date')">
            {{ errors.first('event_end_date') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label class="ts-text-xs required">{{
            $t('luckyDrawAvailableItem.feeAmount')
          }}</label>
          <a-input
            v-model.number="model.fee_amount"
            class="ts-w-full"
            type="number"
          >
            <template #addonAfter>
              <a-select
                v-model="model.currency_id"
                style="width: 70px"
                :options="currencies"
                showSearch
                :filterOption="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
              ></a-select>
            </template>
          </a-input>
          <div class="validate ts-text-xs" v-if="errors.has('fee_amount')">
            {{ errors.first('fee_amount') }}
          </div>
        </div>
        <div class="col-md-6 ts-pt-8">
          <ts-checkbox v-model="model.is_active">{{
            $t('luckyDrawAvailableItem.isActive')
          }}</ts-checkbox>
          <div class="validate ts-text-xs" v-if="errors.has('is_active')">
            {{ errors.first('is_active') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div
            class="ts-border ts-border-gray-300 ts-rounded-lg ts-p-3 ts-mt-4"
          >
            <ItemList
              v-model="model"
              :validate="errors"
              :is_update="isUpdate"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 ts-mt-3 text-right">
          <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
            {{ $t('cancel') }}
          </ts-button>
          <ts-button
            v-if="!isUpdate"
            color="primary"
            @click.prevent="onSave"
            :waiting="waiting"
            >{{ $t('save') }}</ts-button
          >
          <ts-button
            v-if="isUpdate"
            color="primary"
            @click.prevent="onUpdate"
            :waiting="waiting"
            >{{ $t('update') }}</ts-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'
import ItemList from './components/item-list.vue'

export default {
  name: 'companyForm',
  components: {
    ItemList
  },
  data () {
    return {
      errors: new Errors(),
      waiting: false,
      model: {
        event_name: null,
        event_start_date: null,
        event_end_date: null,
        item_list: [],
        fee_amount: null,
        currency_id: 1,
        is_active: false
      }
    }
  },
  async created () {
    await this.fetchData()
    this.setEditData()
  },
  computed: {
    ...mapState('luckyDraw/luckyDrawAvailableItem', [
      'edit_data',
      'formViewData'
    ]),
    isUpdate () {
      return !_.isEmpty(this.edit_data)
    },
    currencies () {
      if (!this.formViewData.currency) return []
      return this.formViewData.currency.map(el => ({
        value: el.currency_id,
        label: el.currency_code
      }))
    }
  },
  methods: {
    ...mapActions('luckyDraw/luckyDrawAvailableItem', ['getFormViewData']),
    async fetchData () {
      this.loading = true
      await this.getFormViewData({
        params: undefined,
        index: undefined
      }).finally(() => (this.loading = false))
    },
    async onSave () {
      this.waiting = true
      this.$store
        .dispatch('luckyDraw/luckyDrawAvailableItem/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    async onUpdate () {
      this.waiting = true
      this.$store
        .dispatch('luckyDraw/luckyDrawAvailableItem/update', {
          id: this.edit_data.id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData () {
      if (!_.isEmpty(this.edit_data)) {
        this.model.event_name = this.edit_data.event_name
        this.model.event_start_date = this.edit_data.event_start_date
        this.model.event_end_date = this.edit_data.event_end_date
        this.model.item_list = this.edit_data.item_list
        this.model.fee_amount = this.edit_data.fee_amount
        this.model.currency_id = this.edit_data.currency_id
        this.model.is_active = this.edit_data.is_active
      }
    }
  }
}
</script>
